export const DataAnnual = [
    {
        id:1,
        image:"/images/Annual/1.webp"
    },
    {
        id:2,
        image:"/images/Annual/2.webp"
    },
    {
        id:3,
        image:"/images/Annual/3.webp"
    },
    {
        id:4,
        image:"/images/Annual/4.webp"
    },
    {
        id:5,
        image:"/images/Annual/5.webp"
    },
    {
        id:6,
        image:"/images/Annual/6.webp"
    },
    {
        id:7,
        image:"/images/Annual/7.webp"
    },
    {
        id:8,
        image:"/images/Annual/8.webp"
    },
    {
        id:9,
        image:"/images/Annual/9.webp"
    },
    {
        id:10,
        image:"/images/Annual/10.webp"
    },
    {
        id:11,
        image:"/images/Annual/11.webp"
    },
    {
        id:12,
        image:"/images/Annual/12.webp"
    },
    {
        id:13,
        image:"/images/Annual/13.webp"
    },
    {
        id:14,
        image:"/images/Annual/14.webp"
    },
    {
        id:15,
        image:"/images/Annual/15.webp"
    },
    {
        id:16,
        image:"/images/Annual/16.webp"
    },
    {
        id:17,
        image:"/images/Annual/17.webp"
    },
    {
        id:18,
        image:"/images/Annual/18.webp"
    },
    {
        id:19,
        image:"/images/Annual/19.webp"
    },
    {
        id:20,
        image:"/images/Annual/20.webp"
    },
    {
        id:21,
        image:"/images/Annual/21.webp"
    },
    {
        id:22,
        image:"/images/Annual/22.webp"
    },
    {
        id:23,
        image:"/images/Annual/23.webp"
    },
    {
        id:24,
        image:"/images/Annual/24.webp"
    },
    {
        id:26,
        image:"/images/Annual/26.webp"
    },
    {
        id:27,
        image:"/images/Annual/27.webp"
    },
    {
        id:28,
        image:"/images/Annual/28.webp"
    },
    {
        id:29,
        image:"/images/Annual/29.webp"
    },
    {
        id:30,
        image:"/images/Annual/30.webp"
    },
    {
        id:31,
        image:"/images/Annual/31.webp"
    },
];
